<template>
  <!-- Loading Modal -->
  <div class="modal-messages" v-show="modal_message.showModalLoading">
    <div class="inside-modal-edit-company">
      <ButtonClose
        @btnAbort="
          modal_message.showModalLoading = !modal_message.showModalLoading
        "
      />
      <!-- Logo -->
      <div class="row f-row text-center">
        <div class="col col-12 mt-3">
          <img
            :src="logo"
            @mouseover="logo = logo_blue"
            @mouseout="logo = logo_white"
            height="30"
            alt=""
            style="padding: 0"
          />
        </div>
      </div>
      <div
        class="row f-row text-center"
        style="border-bottom: 1px solid var(--graylightbackground) !important;"
      >
        <div class="col col-12 mt-2 mb-3">
          EDIT COMPANY NAME AND CREATE/EDIT/DELETE PORTFOLIOS
        </div>
      </div>
      <!-- ============= form =============  -->
      <div class="row f-row justify-content-center">
        <div class="col col-auto">
          <form @submit.prevent="validateBeforeSubmit">
            <table
              class="table table-sm table-responsive table-borderless table-data-controls my-data-table"
              style="width: 100%;"
            >
              <tbody>
                <tr style="width: 100%;">
                  <td style="width: 80%;">
                    <label class="txt-label">
                      <i
                        v-show="errors.has('company_name')"
                        class="fa fa-warning warn-my-data"
                      ></i>
                      Company name:
                    </label>
                    <input
                      v-validate="'required|max:30'"
                      class="custom-input-2"
                      name="company_name"
                      placeholder="Name"
                      v-model="companiesCopy[selectedCompany].company_name"
                      :class="{
                        input: true,
                        'is-danger': errors.has('company_name'),
                      }"
                      type="text"
                    />
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in companiesCopy[selectedCompany]
                    .portfolios"
                  :key="index"
                  style="width: 100%;"
                >
                  <td style="width: 80%;">
                    <label class="txt-label">
                      <i
                        v-show="errors.has('portfolio_name')"
                        class="fa fa-warning warn-my-data"
                      ></i>
                      Portfolio {{ index + 1 }}:
                    </label>
                    <input
                      v-validate="'required|max:30'"
                      class="custom-input-2"
                      name="portfolio_name"
                      placeholder="Name"
                      v-model="item.portfolio_name"
                      :class="{
                        input: true,
                        'is-danger': errors.has('portfolio_name'),
                      }"
                      type="text"
                    />
                  </td>
                  <td
                    style="width: 10%;"
                    class="align-bottom"
                    v-if="portfolioLength > 1"
                  >
                    <button
                      v-on:click="onDeleteItem(index)"
                      type="button"
                      class="btn-edit-delete"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
                <tr style="width: 100%;">
                  <td style="width: 80%;">
                    <label class="txt-label">
                      <i
                        v-show="errors.has('newPortfolio')"
                        class="fa fa-warning warn-my-data"
                      ></i>
                      Create New Portfolio:
                    </label>
                    <input
                      v-validate="'max:30'"
                      class="custom-input-2"
                      name="newPortfolio"
                      :placeholder="placeholder"
                      v-model="newPortfolio"
                      :class="{
                        input: true,
                        'is-danger': errors.has('newPortfolio'),
                      }"
                      type="text"
                    />
                  </td>
                  <td
                    style="width: 10%;"
                    class="align-bottom"
                    v-if="addAllowed === true"
                  >
                    <button
                      v-on:click="onCreatePortfolio()"
                      type="button"
                      class="btn-edit-delete"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- ============= Buttons =============  -->
            <div class="row f-row">
              <div
                class="col col-6 text-right align-right"
                style="padding-right: 5px;"
              >
                <button
                  v-on:click="
                    modal_message.showModalLoading = !modal_message.showModalLoading
                  "
                  type="button"
                  class="btn btn-sm btn-home btn-abort"
                >
                  Cancel
                </button>
              </div>
              <div
                class="col col-6 text-left align-left"
                style="padding-left: 5px;"
              >
                <button
                  v-on:click="
                    modal_message.showModalLoading = !modal_message.showModalLoading
                  "
                  type="submit"
                  class="btn btn-sm btn-home"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- ============= Show Errors =============  -->
      <div class="row f-row mt-3">
        <div class="col col-2"></div>
        <div class="col col-8 btn-warn">
          <span v-show="errors.has('company_name')"
            >{{ errors.first("company_name") }}.<br
          /></span>
          <span v-show="errors.has('portfolio_name')"
            >{{ errors.first("portfolio_name") }}.<br
          /></span>
          <span v-show="errors.has('newPortfolio')"
            >{{ errors.first("newPortfolio") }}.<br
          /></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from "@/_services";
import { Company } from "@/_core/data/Company";
import ButtonClose from "../buttons/Close";
export default {
  name: "CompanyPortfoliosEdit",
  components: {
    ButtonClose,
  },
  props: {
    modal_message: { required: true },
    companies: { required: true },
    selectedCompany: { required: true },
    watcherForEditCompany: { required: true },
    user: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
  },
  data() {
    return {
      newPortfolio: "",
      companiesCopy: [],
      allPortfolios: [],
      placeholder: "New Portfolio Name",
      portfolioLength: 0,
      addAllowed: false,
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      deleted_porfolios: [],
      sended_porfolios: [],
      showLoading: false,
    };
  },
  created() {
    this.initializeVars();
    try {
      this.processed_company = new Company(this);
    } catch (error) {
      console.log(`Error companies loader ${error}`);
    }
  },
  mounted() {
    if (this.colorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
      this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
    } else if (!this.colorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
      this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
    }
  },
  watch: {
    colorTheme() {
      if (this.colorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
        this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
      } else if (!this.colorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
      }
    },
    watcherForEditCompany() {
      this.initializeVars();
    },
    allPortfolios(val) {
      this.portfolioLength = val.length;
    },
    newPortfolio(val) {
      this.addAllowed =
        val !== "" && this.allPortfolios.indexOf(val.trim().toUpperCase()) < 0;
    },
  },
  methods: {
    initializeVars() {
      this.allPortfolios = this.companies[
        this.selectedCompany
      ].portfolios.map((d) => d.portfolio_name.trim().toUpperCase());
      this.companiesCopy = JSON.parse(JSON.stringify(this.companies));
      this.newPortfolio = "";
    },
    onCreatePortfolio() {
      let vis = this;
      if (
        this.newPortfolio !== "" &&
        this.allPortfolios.indexOf(this.newPortfolio.toUpperCase()) < 0
      ) {
        this.companiesCopy[this.selectedCompany].portfolios.push({
          pk_idportfolio: NaN,
          fk_currency: [],
          fk_idcommodity: [],
          portfolio_name: this.newPortfolio.trim(),
          created_at: "",
          show: true,
          fk_idcompany: vis.companiesCopy[vis.selectedCompany].pk_idcompany,
          fk_idstate: 1,
        });
        this.allPortfolios.push(this.newPortfolio.trim().toUpperCase());
        this.newPortfolio = "";
        this.placeholder = "New Portfolio Name";
      } else {
        if (!(this.newPortfolio !== "")) {
          this.placeholder = "Name required";
        } else {
          this.placeholder = "Name already exists";
        }
        this.newPortfolio = "";
      }
    },
    onDeleteItem(idx) {
      if (this.companiesCopy[this.selectedCompany].portfolios.length > 1) {
        this.companiesCopy[this.selectedCompany].portfolios[idx].fk_idstate = 2;

        this.deleted_porfolios.push(
          this.companiesCopy[this.selectedCompany].portfolios[idx],
        );
        this.companiesCopy[this.selectedCompany].portfolios.splice(idx, 1);
        this.allPortfolios.splice(idx, 1);
      }
    },
    validateBeforeSubmit() {
      this.showLoading = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveChanges();
          this.showModalEditHedge = false;
          return;
        }
        return;
      });
    },

    saveChanges() {
      this.sended_porfolios = this.companiesCopy[
        this.selectedCompany
      ].portfolios.concat(this.deleted_porfolios);
      this.onBeforeSavePortfolioCompany();
      let company_portfolios = this.sended_porfolios.map(function(portfolio) {
        return {
          portfolio_name: portfolio.portfolio_name,
          portfolio_id: portfolio.pk_idportfolio,
          fk_idstate: portfolio.fk_idstate,
        };
      });

      /***
       *
       * Registro de datos primera vez, compañías
       *
       */
      let params = {
        method: "PUT",
        endpoint: `infouser/${
          this.companiesCopy[this.selectedCompany].pk_idcompany
        }`,
        content_type: "application/json",
        query_params: {
          format: "json",
          company_name: this.companiesCopy[this.selectedCompany].company_name,
          portfolios: company_portfolios,
          fk_iduser: [
            {
              pk_idusers: this.user.pk_idusers,
            },
          ],
        },
      };
      var delay_state = this;
      apiService
        .getAll(params)
        .then((data) => {
          this.processed_company.onLoadData();
          setTimeout(function() {
            this.showLoading = false;
            delay_state.onAfterSavePortfolioCompany(data);
            this.saveLegendExpo = "Saved:";
            this.refreshLegendExpo = "Synced:";
          }, 10000);
        })
        .catch(function(error) {
          console.log("An error has ocurred" + error);
        });

      this.dataSavedHedge = false;
      this.saveLegendHedge = "Save:";
      this.refreshLegendHedge = "Discard:";
    },
    onAfterSavePortfolioCompany(item) {
      this.$emit("eventOnAfterSavePortfolioCompany", item);
    },
    onBeforeSavePortfolioCompany() {
      this.$emit("eventOnBeforeSavePortfolioCompany");
    },
  },
};
</script>

<style scoped></style>
